// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../utils/Utils.bs.js");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ViewStack = require("../../reason/common/ViewStack.bs.js");
let View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
let Next__Image = require("../../reason/next/Next__Image.bs.js");
let NukaCarousel = require("nuka-carousel").default;
let TailwindMerge = require("tailwind-merge");
let TailwindVariants = require("../../v5/bindings/TailwindVariants.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactAriaComponents = require("react-aria-components");
let VisuallyHidden = require("@reach/visually-hidden").default;
let UseWindowSize = require("uikit/hooks/useWindowSize");

let defaultControlsConfig = {};

let Nuka = {
  defaultControlsConfig: defaultControlsConfig
};

function fromAttachment(param) {
  let key = param.key;
  return {
    fullscreen: Utils.makeAttachmentUrl(1200, undefined, undefined, undefined, 1, undefined, key),
    large: Utils.makeAttachmentUrl(1200, 800, undefined, true, undefined, undefined, key),
    small: Utils.makeAttachmentUrl(750, 500, undefined, true, undefined, undefined, key),
    thumb: Utils.makeAttachmentUrl(90, 90, true, undefined, undefined, undefined, key)
  };
}

let CarouselImg_width = {
  large: 1200,
  small: 750
};

let CarouselImg_height = {
  large: 800,
  small: 500
};

let CarouselImg = {
  width: CarouselImg_width,
  height: CarouselImg_height,
  fromAttachment: fromAttachment
};

function TMPUIKIT____ImgGallery$ResponsiveImage(props) {
  let imgSize = props.imgSize;
  let alt = props.alt;
  let image = props.image;
  let match = imgSize === "fullscreen" ? [
      image.fullscreen,
      1200,
      undefined
    ] : (
      imgSize === "small" ? [
          image.small,
          750,
          500
        ] : [
          image.large,
          1200,
          800
        ]
    );
  let src = match[0];
  if (imgSize === "fullscreen") {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Next__Image.make, {
        src: src,
        fill: true,
        unoptimized: true,
        alt: alt,
        className: "object-contain"
      }),
      className: "w-full h-full relative"
    });
  } else {
    return JsxRuntime.jsx(Next__Image.make, {
      src: src,
      width: match[1],
      height: match[2],
      unoptimized: true,
      alt: alt,
      className: "object-contain w-full h-auto"
    });
  }
}

let ResponsiveImage = {
  make: TMPUIKIT____ImgGallery$ResponsiveImage
};

function TMPUIKIT____ImgGallery$TransparentButton(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(ReactAriaComponents.Button, {
    children: props.children,
    className: v => TailwindMerge.twMerge([
      "appearance-none border-0 bg-transparent p-0 m-0 rounded",
      TailwindVariants.Utils.focusRing({
        isFocusVisible: v.isFocusVisible
      }),
      className
    ]),
    onClick: props.onClick
  });
}

let TransparentButton = {
  make: TMPUIKIT____ImgGallery$TransparentButton
};

let selectedShadowClass = "shadow-[0_0_3px_1px_#28618d]";

let unselectedShadowClass = "shadow-[0_0_3px_1px_transparent]";

function thumbnailStyles(highlightSelected, isSelected) {
  let shadow = isSelected && highlightSelected ? selectedShadowClass : unselectedShadowClass;
  return TailwindMerge.twMerge([
    "transform transition-all ease-linear duration-100 cursor-pointer flex items-center justify-center text-base font-bold bg-black/10 hover:scale-110",
    shadow
  ]);
}

function TMPUIKIT____ImgGallery$ImageThumbnails(props) {
  let __onSelectExtra = props.onSelectExtra;
  let onSelect = props.onSelect;
  let __imageSize = props.imageSize;
  let __maxLength = props.maxLength;
  let selectedIndex = props.selectedIndex;
  let images = props.images;
  let __highlightSelected = props.highlightSelected;
  let highlightSelected = __highlightSelected !== undefined ? __highlightSelected : true;
  let maxLength = __maxLength !== undefined ? __maxLength : 12;
  let imageSize = __imageSize !== undefined ? __imageSize : 75;
  let onSelectExtra = __onSelectExtra !== undefined ? __onSelectExtra : prim => {};
  let makeThumbnail = (img, i) => JsxRuntime.jsx(TMPUIKIT____ImgGallery$TransparentButton, {
    onClick: param => onSelect(i),
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("img", {
        className: "object-cover",
        height: imageSize.toString(),
        src: img.thumb,
        width: imageSize.toString()
      }),
      className: thumbnailStyles(highlightSelected, selectedIndex === i),
      style: {
        height: imageSize.toString() + "px",
        width: imageSize.toString() + "px"
      }
    })
  }, img.thumb);
  return JsxRuntime.jsx("div", {
    children: images.length > (maxLength + 1 | 0) ? images.filter((param, i) => i < maxLength).map(makeThumbnail).concat([JsxRuntime.jsx(TMPUIKIT____ImgGallery$TransparentButton, {
          onClick: param => {
            onSelect(maxLength);
            onSelectExtra();
          },
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: "+" + (images.length - maxLength | 0).toString()
            }),
            className: thumbnailStyles(highlightSelected, selectedIndex >= maxLength),
            style: {
              height: imageSize.toString() + "px",
              width: imageSize.toString() + "px"
            }
          })
        }, "extra")]) : images.map(makeThumbnail),
    className: "grid justify-center w-full mb-4 gap-4 px-4",
    style: {
      gridTemplateColumns: "repeat(auto-fit, " + imageSize.toString() + "px)"
    }
  });
}

let ImageThumbnails = {
  View: undefined,
  selectedShadowClass: selectedShadowClass,
  unselectedShadowClass: unselectedShadowClass,
  thumbnailStyles: thumbnailStyles,
  make: TMPUIKIT____ImgGallery$ImageThumbnails
};

let onImageClass = "absolute top-2.5 left-1/2 -translate-x-1/2 p-[5px] bg-black/40 text-white";

let aboveImageClass = "absolute top-[-40px] left-1/2 -translate-x-1/2 p-[5px] text-white";

function TMPUIKIT____ImgGallery$SlideNumber(props) {
  return JsxRuntime.jsx("div", {
    children: (props.index + 1 | 0).toString() + (" of " + (props.length.toString() + " photos")),
    className: props.position === "onImage" ? onImageClass : aboveImageClass
  });
}

let SlideNumber = {
  onImageClass: onImageClass,
  aboveImageClass: aboveImageClass,
  make: TMPUIKIT____ImgGallery$SlideNumber
};

let openModalButtonContainerClass = "absolute top-2.5 right-2.5 p-[5px] bg-black/40 cursor-pointer rounded z-[1] text-white hover:bg-black/50";

let nextButton = JsxRuntime.jsxs(JsxRuntime.Fragment, {
  children: [
    JsxRuntime.jsx(VisuallyHidden, {
      children: "Next"
    }),
    JsxRuntime.jsx(IconV5.make, {
      icon: "arrow-right"
    })
  ]
});

let prevButton = JsxRuntime.jsxs(JsxRuntime.Fragment, {
  children: [
    JsxRuntime.jsx(VisuallyHidden, {
      children: "Previous"
    }),
    JsxRuntime.jsx(IconV5.make, {
      icon: "arrow-left"
    })
  ]
});

let defaultControlsConfig_containerClassName = defaultControlsConfig.containerClassName;

let defaultControlsConfig_nextButtonStyle = defaultControlsConfig.nextButtonStyle;

let defaultControlsConfig_prevButtonStyle = defaultControlsConfig.prevButtonStyle;

let defaultControlsConfig_pagingDotsContainerClassName = defaultControlsConfig.pagingDotsContainerClassName;

let defaultControlsConfig_pagingDotsStyle = defaultControlsConfig.pagingDotsStyle;

let defaultControlsConfig$1 = {
  containerClassName: defaultControlsConfig_containerClassName,
  nextButtonClassName: "flex items-center text-white",
  nextButtonStyle: defaultControlsConfig_nextButtonStyle,
  nextButtonText: nextButton,
  prevButtonClassName: "flex items-center text-white",
  prevButtonStyle: defaultControlsConfig_prevButtonStyle,
  prevButtonText: prevButton,
  pagingDotsContainerClassName: defaultControlsConfig_pagingDotsContainerClassName,
  pagingDotsClassName: "px-[6px] py-[1px]",
  pagingDotsStyle: defaultControlsConfig_pagingDotsStyle
};

function TMPUIKIT____ImgGallery$Carousel(props) {
  let imgSize = props.imgSize;
  let __maxThumbnails = props.maxThumbnails;
  let selectedIndex = props.selectedIndex;
  let onSelect = props.onSelect;
  let openModal = props.openModal;
  let images = props.images;
  let maxThumbnails = __maxThumbnails !== undefined ? __maxThumbnails : 24;
  let windowSize = UseWindowSize.useWindowSize();
  let maxDots = imgSize === "small" ? Math.min(windowSize.width - 50 | 0, 668) / 20 | 0 : (windowSize.width - 30 | 0) / 20 | 0;
  return JsxRuntime.jsxs(ViewStack.make, {
    alignItems: "center",
    flexDirection: "column",
    className: "relative flex flex-col items-center",
    children: [
      openModal !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(TMPUIKIT____ImgGallery$TransparentButton, {
            onClick: param => openModal(),
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "full-size-view"
            })
          }),
          className: openModalButtonContainerClass
        }) : null,
      JsxRuntime.jsx(NukaCarousel, {
        beforeSlide: (_prev, nextIndex) => onSelect(nextIndex),
        children: images.map((img, index) => JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(TMPUIKIT____ImgGallery$ResponsiveImage, {
            image: img,
            alt: index.toString(),
            imgSize: imgSize
          }),
          className: imgSize === "fullscreen" ? "inline-flex items-center w-full h-[calc(100vh-190px)]" : "inline-flex items-center"
        }, img.thumb)),
        defaultControlsConfig: defaultControlsConfig$1,
        enableKeyboardControls: true,
        getControlsContainerStyles: position => {
          if (position !== "BottomCenter") {
            return {
              width: "auto"
            };
          }
          let widthPx = (maxDots * 20 | 0).toString() + "px";
          return {
            alignItems: "center",
            bottom: "-4px",
            display: "flex",
            justifyContent: "center",
            margin: "0 auto",
            minHeight: "24px",
            overflowX: "hidden",
            overflowY: "visible",
            width: widthPx
          };
        },
        slideIndex: selectedIndex
      }, windowSize.width.toString()),
      JsxRuntime.jsx(TMPUIKIT____ImgGallery$SlideNumber, {
        index: selectedIndex,
        length: images.length,
        position: imgSize === "fullscreen" ? "aboveImage" : "onImage"
      }),
      JsxRuntime.jsx(TMPUIKIT____ImgGallery$ImageThumbnails, {
        images: images,
        selectedIndex: selectedIndex,
        maxLength: maxThumbnails,
        onSelect: onSelect,
        onSelectExtra: openModal
      })
    ]
  });
}

let Carousel = {
  openModalButtonContainerClass: openModalButtonContainerClass,
  nextButton: nextButton,
  prevButton: prevButton,
  defaultControlsConfig: defaultControlsConfig$1,
  make: TMPUIKIT____ImgGallery$Carousel
};

let className = "absolute top-2.5 left-1/2 -translate-x-1/2 p-[5px] bg-[rgba(34,34,34,0.66)] text-white text-sm font-medium rounded-[5px]";

function TMPUIKIT____ImgGallery$LightCarousel$LightSlideNumber(props) {
  return JsxRuntime.jsx("div", {
    children: (props.index + 1 | 0).toString() + (" / " + props.length.toString()),
    className: className
  });
}

let LightSlideNumber = {
  className: className,
  make: TMPUIKIT____ImgGallery$LightCarousel$LightSlideNumber
};

function TMPUIKIT____ImgGallery$LightCarousel(props) {
  let selectedIndex = props.selectedIndex;
  let onSelect = props.onSelect;
  let openModal = props.openModal;
  let images = props.images;
  let windowSize = UseWindowSize.useWindowSize();
  return JsxRuntime.jsxs(View__Jsx3.make, {
    alignItems: "center",
    flexDirection: "column",
    className: "relative flex flex-col items-center",
    children: [
      JsxRuntime.jsx(NukaCarousel, {
        beforeSlide: (_prev, nextIndex) => onSelect(nextIndex),
        children: images.map(img => JsxRuntime.jsx(TMPUIKIT____ImgGallery$TransparentButton, {
          onClick: param => openModal(),
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(TMPUIKIT____ImgGallery$ResponsiveImage, {
              image: img,
              alt: "",
              imgSize: "small"
            }),
            className: "inline-flex items-center w-full h-[calc(100vh-190px)]"
          })
        }, img.thumb)),
        enableKeyboardControls: true,
        slideIndex: selectedIndex,
        withoutControls: true
      }, windowSize.width.toString()),
      JsxRuntime.jsx(TMPUIKIT____ImgGallery$LightCarousel$LightSlideNumber, {
        index: selectedIndex,
        length: images.length
      })
    ]
  });
}

let LightCarousel = {
  LightSlideNumber: LightSlideNumber,
  make: TMPUIKIT____ImgGallery$LightCarousel
};

function TMPUIKIT____ImgGallery$CarouselDialog(props) {
  let onDismiss = props.onDismiss;
  return JsxRuntime.jsxs(DialogV5.make, {
    isOpen: props.isOpen,
    ariaLabel: "Image Gallery",
    onDismiss: onDismiss,
    customContent: true,
    size: "FullScreen",
    showCloseButton: false,
    overlayClassName: "bg-black/95 backdrop-blur-[3px] backdrop-brightness-[.8] backdrop-saturate-[.3] flex flex-col items-center px-0 pt-0 pb-0",
    modalClassName: "w-screen max-w-[120vh] m-0 p-0 bg-transparent rounded-none shadow-none h-full flex flex-col",
    transitionOnDestroyed: props.transitionOnDestroyed,
    children: [
      JsxRuntime.jsxs(ReactAriaComponents.Button, {
        children: [
          JsxRuntime.jsx(VisuallyHidden, {
            children: "Close"
          }),
          JsxRuntime.jsx(IconV5.make, {
            icon: "cancel",
            size: 24,
            className: "text-white"
          })
        ],
        className: param => "fixed top-0 right-0 p-[20px] cursor-pointer focus:outline-none z-[100]",
        onClick: param => onDismiss()
      }),
      JsxRuntime.jsx(View__Jsx3.make, {
        justifyContent: "flexEnd"
      }),
      JsxRuntime.jsx("div", {
        children: props.children,
        className: "flex flex-col items-stretch w-full m-auto pt-16"
      })
    ]
  });
}

let CarouselDialog = {
  make: TMPUIKIT____ImgGallery$CarouselDialog
};

exports.Nuka = Nuka;
exports.CarouselImg = CarouselImg;
exports.ResponsiveImage = ResponsiveImage;
exports.TransparentButton = TransparentButton;
exports.ImageThumbnails = ImageThumbnails;
exports.SlideNumber = SlideNumber;
exports.Carousel = Carousel;
exports.LightCarousel = LightCarousel;
exports.CarouselDialog = CarouselDialog;
/* nextButton Not a pure module */
